import { __rest } from 'tslib';
import React from 'react';
import { styled, Button } from '@teko/ui';
import { space } from 'styled-system';

const Wrapper = styled.div(space, `
    white-space: nowrap;
    display: flex;
  `);
const BreadcrumbBlock = styled.div `
  height: 32px;
  width: fit-content;
  align-items: center;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;
const StyledButton = styled(Button)(({ isDisable, color, outline }) => `
  padding: ${outline ? '8px' : '4px'};
  color: ${isDisable ? 'rgba(0,0,0,.38)' : color};
  text-decoration: none;
  background-color: #FFF;
  pointer-events: ${isDisable ? 'none' : 'auto'};
  border: ${outline ? '1px solid #e0e0e0' : 'none'};
  border-radius: 9999px;
  --button-icon-color: ${color};
  &:hover {
    color: ${color};
    background-color: #FFF;
    --button-icon-color: ${color};
  }
   `);
const Divider = styled.span `
  margin: 0 8px;
  color: #9b9b9b;
  font-size: inherit;
`;
const Breadcrumb = (_a) => {
    var { items, divider, color = '#848788', outline } = _a, props = __rest(_a, ["items", "divider", "color", "outline"]);
    return (React.createElement(Wrapper, Object.assign({}, props), items.map((breadcrumb, index) => {
        return (React.createElement(BreadcrumbBlock, { key: index },
            React.createElement(StyledButton, { icon: breadcrumb.icon, link: true, outline: outline, color: color, isDisable: breadcrumb.disabled, href: breadcrumb.href, tag: "a" }, breadcrumb.text),
            index !== items.length - 1 && React.createElement(Divider, null, divider)));
    })));
};

export { Breadcrumb };
